import createAsyncGetters from '../config/asyncGetters/createAsyncGetters';

export const chatbotAsyncGetters = createAsyncGetters({
  /**
   * Server-side LINE Official Account subscription status: `true` iff either
   * the cached last-known status (webhook-updated, no LINE round-trip) or the
   * realtime LINE check reports subscribed.
   *
   * The cached value is consulted first and trusted when it says subscribed.
   * Only when it says not-subscribed — exactly the case where it may be stale
   * right after a follow — is the realtime `api.chatbot.isSubscribed()` LINE
   * round-trip (rate-limited) made.
   *
   * Both `api.chatbot` calls throw on non-LINE platforms — the frontend wrapper
   * (`isSubscribedToOfficialAccount`) guards that and fails closed; we do not
   * swallow it here so a genuine LINE error still surfaces to monitoring.
   */
  isSubscribedToOfficialAccount: async (_: void, api): Promise<boolean> =>
    (await api.chatbot.getLastKnownIsSubscribed()) ||
    api.chatbot.isSubscribed(),
});
